export default __webpack_public_path__ + "static/media/ransel.0b21976d.jpg";